module.exports = __webpack_public_path__ + "static/media/kiviArticleFeb2020.9aceba2f.pdf";